import {
    Component,
    input,
    output,
    viewChild,
    type InputSignal,
    type OutputEmitterRef,
    type Signal,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatDrawer, type MatDrawerMode, MatDrawerContainer } from '@angular/material/sidenav';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDrawerContainer, MatDrawer],
    selector: 'app-drawer-container',
    styleUrl: './drawer-container.component.scss',
    templateUrl: './drawer-container.component.html',
})
export class DrawerContainerComponent {
    public readonly mode: InputSignal<MatDrawerMode> = input<MatDrawerMode>('side');

    public readonly position: InputSignal<'start' | 'end'> = input<'start' | 'end'>('end');

    public readonly opened: InputSignal<boolean> = input<boolean>(false);

    public readonly closeDrawer: OutputEmitterRef<void> = output<void>();

    public readonly drawerComponent: Signal<MatDrawer> = viewChild.required(MatDrawer);

    public open(): void {
        this.drawerComponent().open();
    }

    public close(): void {
        this.closeDrawer.emit();
        this.drawerComponent().close();
    }
}
